/**
 * Outbound links that appear in more than one place.
 *
 * The Discord invite is `discord.gg/carousel`; the older `discord.gg/carouselgg`
 * vanity URL is retired.
 */
export const DISCORD_INVITE = 'https://discord.gg/carousel'
